<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="payNode.payNodeID > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="500px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="payNode"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-form-item label="节点名称" prop="payNodeName">
          <el-input v-model="payNode.payNodeName" placeholder="请输入"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

  export default {
    name:"PayNodeEdit",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        payNode: {
          payNodeID: "",
          payNodeName: "",
        },
        ruleValidate: {
          payNodeName: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.payNode.payNodeID = id;
        // console.log(id);
        this.dialogVisible = true;
        if(id>0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `payNodes/${this.payNode.payNodeID}`)
          .then(resp => {
            this.payNode = resp;
          });
      },
      handleSubmit() {
        if(this.payNode.payNodeID>0) {
          this.handleSubmitUpData();
        }else {
          this.handleSubmitSave();
        }
      },
      handleSubmitUpData() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "payNodes", this.payNode)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "payNodes", this.payNode)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
